import { useMemo } from "react";
import { useOrigin } from "./origin";
import { activeItemChain } from "./paths";
import type { MatchedContext, UpTarget } from "./types";

function useNoParentLabel(): string | null {
  return null;
}

/**
 * Header, items, active chain and up target of a matched context.
 * Calls the context's hooks: render the caller with `key={matched.def.type}`
 * so the hook order stays stable when the context type changes.
 */
export function useContextNav(matched: MatchedContext, pathname: string) {
  const { def, params } = matched;
  const header = def.useHeader(params);
  const items = def.useItems(params);
  const useParentLabel = def.useParentLabel ?? useNoParentLabel;
  const parentLabel = useParentLabel(params);
  const origin = useOrigin(matched.key);
  const activeChain = useMemo(
    () => activeItemChain(items, pathname),
    [items, pathname],
  );
  const parent = def.parent(params);
  const up: UpTarget & { isOrigin: boolean } = origin
    ? { ...origin, isOrigin: true }
    : { ...parent, label: parentLabel || parent.label, isOrigin: false };

  return { header, items, activeChain, up };
}
